import React from "react";

import ReactDOM from "react-dom/client";

import "./index.css";

import App from "./App";

import theme from "./Theme";

import { ThemeProvider } from "@mui/material/styles";

import CssBaseline from "@mui/material/CssBaseline";

import { purgeBloatedSessionCaches } from "./utils/apiCache";

purgeBloatedSessionCaches();

function isIgnorableRuntimeNoise(reason) {
  if (reason == null || reason === "") return true;
  const name = reason?.name || "";
  const message = String(reason?.message || reason || "");
  const stack = String(reason?.stack || "");
  if (name === "AbortError" || name === "NotFoundError" || /abort/i.test(message))
    return true;
  if (/removeChild|insertBefore|not a child of this node|unable to quit unity/i.test(message))
    return true;
  if (/GLctx|deleteContext|webgl_destroy_context|emscripten_webgl/i.test(`${message}\n${stack}`))
    return true;
  const isFailedFetch =
    (name === "TypeError" || name === "Error") &&
    /failed to fetch|networkerror|load failed|network request failed/i.test(
      message,
    );
  if (!isFailedFetch) return false;
  const text = `${message}\n${stack}`;
  return (
    message === "Failed to fetch" ||
    /gtag|googletagmanager|google-analytics|analytics|chrome-extension|frame_ant|moz-extension/i.test(
      text,
    )
  );
}

window.addEventListener(
  "unhandledrejection",
  (event) => {
    const reason = event.reason;
    const onAimTrain = window.location.pathname.includes("ga-fps");
    const isEmptyUnityReject = onAimTrain && (reason == null || reason === "");
    if (!isEmptyUnityReject && !isIgnorableRuntimeNoise(reason)) return;
    event.preventDefault();
  },
  true,
);

window.addEventListener(
  "error",
  (event) => {
    if (!isIgnorableRuntimeNoise(event.error || event.message)) return;
    event.preventDefault();
  },
  true,
);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <App />
  </ThemeProvider>,
  // </React.StrictMode>
  // React would enable Strict Mode, which helps developers detect potential problems in their application during development.
);
